<script>
import DatePicker from "vue2-datepicker";
import Warehouse from "@/components/modals/property-warehouse.vue";
import { required } from "vuelidate/lib/validators";
export default {
    name: 'DeliveryModal',
    props: {
        modalTitle: {
            type: String,
            default: "Delivery Modal"
        },
        cycles: {
            type: Array,
            default: () => []
        }
    },
    components: {
        DatePicker,
        Warehouse
    },
    data() {
        return {
            submitted: false,
            form: {
                poNumber: "",
                supplier: "",
                poId: null,
                dateOfDelivery: "",
                dateInspected: "",
                acceptanceDate: "",
                drNumber: "",
                cycle: "",
                supplySignatoryId: "",
                supplySignatoryPosition: "",
                inspectionHeadId: "",
                sendEmail: true,
                formItems: [],
                iarItems: []
            }
        };
    },
    validations: {
        form: {
            dateOfDelivery: { required },
            acceptanceDate: { required },
            drNumber: { required },
            cycle: { required }
        }
    },
    methods: {
        onReset() {
            this.submitted = false;
            this.form = {
                poNumber: "",
                supplier: "",
                poId: null,
                dateOfDelivery: "",
                dateInspected: "",
                acceptanceDate: "",
                drNumber: "",
                cycle: "",
                supplySignatoryId: "",
                supplySignatoryPosition: "",
                inspectionHeadId: "",
                sendEmail: true,
                formItems: [],
                iarItems: []
            };
        },
        setData(props){
            this.onReset();
            this.form.poNumber = props.poNumber;
            this.form.supplier = props.supplierName;
            this.form.poId = props.id;
            this.form.dateOfDelivery = new Date();
            this.form.acceptanceDate = new Date();
            this.form.createAndPost = false;
            this.form.cycle = this.$store.state.data.cycle;
            this.form.toggleAllOffer = true;
            this.form.toggleAllRequest = false;
            this.form.toggleAllWarehouse = false;
            props.rfqSupplierOffers.forEach((item) => {
                if (item.toggleSelected === true) {
                    this.form.formItems.push({
                        toggleOffer: true,
                        toggleRequest: false,
                        iarId: 0,
                        rfqSupplierOfferId: item.id,
                        offerName: item.itemName,
                        offerDescription: item.description,
                        requestName: item.apiResourceItemName,
                        requestDescription: item.apiResourceDescription,
                        itemName: "",
                        description: "",
                        brand: item.brand,
                        model: item.model,
                        specification: item.specification,
                        color: item.color,
                        dimensionDescription: item.dimensionDescription,
                        materialUsed: item.materialUsed,
                        packageDescription: item.packageDescription,
                        condition: "New",
                        itemCategoryId: item.itemCategoryId,
                        itemCategoryName: item.itemCategory,
                        warrantyStartDate: "",
                        warrantyEndDate: "",
                        unitId: item.unitId,
                        unitName: item.unit ? item.unit.unitName : "",
                        notes: "",
                        quantity: 0,
                        qtyDelivered: item.availableItemsForIar.toString(),
                        qtyWaived: 0,
                        qtyPending: 0,
                        max: item.availableItemsForIar.toString(),
                        unitCost: item.unitCost.toString(),
                        isDelivered: false,
                        locationAreaId: 0,
                        locationAreaName: ""
                    });
                }
            });
        },
        checkIfWaived() {
            var count = 0;
            this.form.formItems.forEach((item) => {
                if (item.qtyDelivered == 0 && item.qtyWaived > 0) count++;
            });
            if (count < this.form.formItems.length) return true;
        },
        toggleAllIarName() {
            this.form.formItems.forEach((item) => {
                item.toggleOffer = this.form.toggleAllOffer;
                item.toggleRequest = this.form.toggleAllRequest;
            });
        },
        checkIarName() {
            var countOffer = 0;
            var countRequested = 0;
            this.form.formItems.forEach((item) => {
                if (item.toggleOffer) countOffer++;
                if (item.toggleRequest) countRequested++;
            });
            if (countOffer === this.form.formItems.length) {
                this.form.toggleAllOffer = true;
            } else {
                this.form.toggleAllOffer = false;
            }
            if (countRequested === this.form.formItems.length) {
                this.form.toggleAllRequest = true;
            } else {
                this.form.toggleAllRequest = false;
            }
        },
        getWarehouse(props) {
            this.itemIndex = this.form.formItems.indexOf(props);
            this.$refs.warehouse.getData(this.$store.state.data.selectedCampus.id);
            this.$bvModal.show("warehouse-modal");
        },
        dropWarehouse(data) {
            if (this.form.toggleAllWarehouse) {
                this.form.formItems.forEach((item) => {
                item.locationAreaId = data.id;
                item.locationAreaName = data.areaName;
                });
                this.$forceUpdate();
            } else {
                this.form.formItems[this.itemIndex].locationAreaId = data.id;
                this.form.formItems[this.itemIndex].locationAreaName = data.areaName;
                this.$forceUpdate();
            }
        },
        removeWarehouse(props) {
            if (this.form.toggleAllWarehouse) {
                this.form.formItems.forEach((item) => {
                item.locationAreaId = 0;
                item.locationAreaName = "";
                });
                this.$forceUpdate();
            } else {
                this.itemIndex = this.form.formItems.indexOf(props);
                this.form.formItems[this.itemIndex].locationAreaId = 0;
                this.form.formItems[this.itemIndex].locationAreaName = "";
                this.$forceUpdate();
            }
        },
        toggleAllWarehouseLocation() {
            if (this.form.toggleAllWarehouse) {
                this.form.formItems.forEach((item) => {
                    item.locationAreaId = this.form.formItems[0].locationAreaId;
                    item.locationAreaName = this.form.formItems[0].locationAreaName;
                });
            }
        },
        checkQtyDelivered(row, type) {
            if (type == "delivered") {
                if (parseFloat(row.qtyDelivered) > parseFloat(row.max) - parseFloat(row.qtyWaived)) {
                    row.qtyDelivered = row.qtyPending;
                } else if (row.qtyDelivered == "" || parseFloat(row.qtyDelivered) < 0) {
                    row.qtyDelivered = 0;
                }
            } else if (type == "waived") {
                if (parseFloat(row.qtyWaived) > parseFloat(row.max) - parseFloat(row.qtyDelivered)) {
                    row.qtyWaived = row.qtyPending;
                } else if (row.qtyWaived == "" || parseFloat(row.qtyWaived) < 0) {
                    row.qtyWaived = 0;
                }
            }
            var decimalPending = row.qtyDelivered.toString().includes(".")
                ? row.qtyDelivered.length - row.qtyDelivered.indexOf(".") - 1
                : 0;
            var decimalWaived = row.qtyWaived.toString().includes(".")
                ? row.qtyWaived.length - row.qtyWaived.indexOf(".") - 1
                : 0;
            var decimal =
                decimalPending > decimalWaived ? decimalPending : decimalWaived;
            row.qtyPending = parseFloat(
                parseFloat(row.max) -
                ((row.qtyDelivered != "" ? parseFloat(row.qtyDelivered) : 0) +
                (row.qtyWaived != "" ? parseFloat(row.qtyWaived) : 0))
            ).toFixed(decimal);
        },
        checkQtyEmpty(qty, pending) {
            if (qty != null && pending != null) {
                if (parseFloat(qty) == parseFloat(pending)) return true;
                else return false;
            }
        },
        checkMax(qty, max) {
            if (qty != null && max != null) {
                if (parseFloat(qty) < 0 || parseFloat(qty) > parseFloat(max))
                    return true;
                else return false;
            }
        },
        checkCreateForm() {
            var count = 0;
            this.form.formItems.forEach((item) => {
                if ((!item.toggleOffer && !item.toggleRequest) || this.checkQtyEmpty(item.max, item.qtyPending))
                count++;
                // if (item.qtyDelivered > 0 && item.locationAreaId == null) count++;
            });
            if (count > 0) return true;
        },
        onCreate() {
            this.submitted = true;
            this.$v.$touch();
            if ((this.$v.$invalid && this.checkIfWaived()) || this.checkCreateForm()) return;
            this.$emit('setIar', this.form);
        },  
    }
}
</script>
<template>
    <b-modal 
        id="delivery-modal" 
        :title="modalTitle" 
        size="xxl" 
        title-class="font-18" 
        hide-footer 
        no-close-on-backdrop
    >
        <div class="mb-3">
            <form @submit.prevent="onCreate" class="needs-validation" ref="fcForm">
                <h5 class="mb-0">{{ form.poNumber }}</h5>
                <div class="mb-3">{{ form.supplier }}</div>
                <div class="row mb-3">
                    <div class="col-md-6">
                    <label for="dateOfDelivery">Date of Delivery</label>
                    <date-picker v-model="form.dateOfDelivery" lang="en" placeholder="Enter Date of Delivery..." :class="{
                        'is-invalid': submitted && $v.form.dateOfDelivery.$error
                    }"></date-picker>
                    <div v-if="submitted && $v.form.dateOfDelivery.$error" class="invalid-feedback">
                        <span v-if="!$v.form.dateOfDelivery.required">This value is required.</span>
                    </div>
                    </div>
                    <div class="col-md-6">
                    <label for="cycle">Cycle</label>
                        <b-form-select 
                            id="cycle"
                            v-model="form.cycle" 
                            :options="cycles" 
                            class="form-select" 
                            :class="{
                                'is-invalid': submitted && $v.form.cycle.$error
                            }"
                        ></b-form-select>
                        <div v-if="submitted && $v.form.cycle.$error" class="invalid-feedback">
                            <span v-if="!$v.form.cycle.required">This value is required.</span>
                        </div>
                    </div>
                </div>
                <b-collapse :visible="checkIfWaived()">
                    <div v-if="checkIfWaived()">
                        <div class="row mb-3">
                            <div class="col-md-6">
                            <label for="acceptanceDate">Acceptance Date</label>
                            <date-picker v-model="form.acceptanceDate" lang="en" placeholder="Enter Date of Delivery..." :class="{
                                'is-invalid': submitted && $v.form.acceptanceDate.$error
                            }"></date-picker>
                            <div v-if="submitted && $v.form.acceptanceDate.$error" class="invalid-feedback">
                                <span v-if="!$v.form.acceptanceDate.required">This value is required.</span>
                            </div>
                            </div>
                            <div class="col-md-6">
                            <label for="drNumber">Invoice Number / D.R. Number</label>
                            <input id="drNumber" type="text" v-model="form.drNumber" placeholder="Enter Invoice/D.R. Number..."
                                class="form-control" :class="{
                                'is-invalid': submitted && $v.form.drNumber.$error
                                }" autocomplete="off" />
                            <div v-if="submitted && $v.form.drNumber.$error" class="invalid-feedback">
                                <span v-if="!$v.form.drNumber.required">This value is required.</span>
                            </div>
                            </div>
                        </div>
                    </div>
                </b-collapse>
                <div class="mb-2">
                    <h5 class="text-muted">
                    Delivery Items: {{ form.formItems.length }}
                    </h5>
                    <div style="max-height: 530px; overflow: auto">
                    <table width="100%">
                        <thead>
                        <tr class="border-bottom">
                            <th class="py-2" style="min-width: 150px">
                            <div class="form-check form-checkbox-outline form-check-success">
                                <input type="checkbox" id="allOfferCheckbox" checked="checked"
                                class="form-check-input hide-disable" @change="toggleAllIarName()"
                                v-model="form.toggleAllOffer" :disabled="!form.toggleAllRequest ? true : false" /><label
                                for="allOfferCheckbox" class="form-check-label hide-disable">
                                <b>Supplier Offer</b>
                                </label>
                            </div>
                            </th>
                            <th class="py-2" style="min-width: 150px">
                            <div class="form-check form-checkbox-outline form-check-success">
                                <input type="checkbox" id="allRequestedCheckbox" checked="checked"
                                class="form-check-input hide-disable" @change="toggleAllIarName()"
                                v-model="form.toggleAllRequest" :disabled="!form.toggleAllOffer ? true : false" /><label
                                for="allRequestedCheckbox" class="form-check-label hide-disable">
                                <b>Requested Item</b>
                                </label>
                            </div>
                            </th>
                            <th class="py-2" style="min-width: 150px">Selected Name</th>
                            <th class="py-2" style="width: 400px">
                            <div class="form-check form-checkbox-outline form-check-success">
                                <input type="checkbox" id="AllWarehouseCheckbox" checked="checked"
                                class="form-check-input hide-disable" @change="toggleAllWarehouseLocation()"
                                v-model="form.toggleAllWarehouse" /><label for="AllWarehouseCheckbox"
                                class="form-check-label hide-disable">
                                <b>Warehouse Location</b>
                                </label>
                            </div>
                            </th>
                            <th class="py-2" style="width: 100px">Delivered</th>
                            <th class="py-2" style="width: 100px">Waived</th>
                            <th class="py-2" style="width: 100px">Pending</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="y in form.formItems" :key="y.rfqSupplierOfferId" class="border-bottom">
                            <td class="py-2 align-top">
                            <div class="form-check form-checkbox-outline form-check-success">
                                <input type="checkbox" :id="`offerCheckbox-${y.rfqSupplierOfferId}`" checked="checked"
                                class="form-check-input" :class="{
                                    'hide-disable': !y.toggleRequest
                                }" @change="checkIarName()" v-model="y.toggleOffer"
                                :disabled="!y.toggleRequest ? true : false" /><label
                                :for="`offerCheckbox-${y.rfqSupplierOfferId}`" class="form-check-label" :class="{
                                    'hide-disable': !y.toggleRequest
                                }">
                                <div>
                                    {{ y.offerName }}
                                </div>
                                <small>{{ y.offerDescription }}</small>
                                </label>
                            </div>
                            </td>
                            <td class="py-2 align-top">
                            <div class="form-check form-checkbox-outline form-check-success">
                                <input type="checkbox" :id="`requestedCheckbox-${y.rfqSupplierOfferId}`" checked="checked"
                                class="form-check-input" :class="{
                                    'hide-disable': !y.toggleOffer
                                }" @change="checkIarName()" v-model="y.toggleRequest"
                                :disabled="!y.toggleOffer ? true : false" /><label
                                :for="`requestedCheckbox-${y.rfqSupplierOfferId}`" class="form-check-label" :class="{
                                    'hide-disable': !y.toggleOffer
                                }">
                                <div>
                                    {{ y.requestName }}
                                </div>
                                <small>{{ y.requestDescription }}</small>
                                </label>
                            </div>
                            </td>
                            <td class="py-2 align-top">
                            <div>
                                {{
                                `${y.toggleRequest ? `${y.requestName}` : ""}${y.toggleRequest && y.toggleOffer ? ", " : " "
                                }${y.toggleOffer ? `${y.offerName}` : ""}`
                                }}
                            </div>
                            <small>{{
                                `${y.toggleRequest ? `${y.requestDescription}` : ""}${y.toggleRequest && y.toggleOffer ? ", " :
                                " "
                                }${y.toggleOffer ? `${y.offerDescription}` : ""}`
                            }}</small>
                            </td>
                            <td class="py-2 align-top pe-2">
                            <b-input-group>
                                <template #append>
                                <b-button v-if="y.locationAreaId > 0" @click="removeWarehouse(y)" variant="outline-danger"><i
                                    class="mdi mdi-close"></i></b-button>
                                <b-button v-else @click="getWarehouse(y)" variant="outline-info"><i
                                    class="mdi mdi-clipboard-text-search-outline"></i></b-button>
                                </template>
                                <input autocomplete="off" type="text" disabled placeholder="Search Warehouse Location..."
                                class="form-control" :class="{
                                    'is-invalid':
                                    submitted &&
                                    (y.locationAreaId === '' ||
                                        y.locationAreaId === null)
                                }" v-model="y.locationAreaName" />
                            </b-input-group>
                            <div v-if="
                                submitted &&
                                (y.locationAreaId === '' ||
                                y.locationAreaId === null)
                            " class="invalid-feedback">
                                <span>This value is required.</span>
                            </div>
                            </td>
                            <td class="py-2 pe-2 align-top text-warning">
                            <input type="number" @change="checkQtyDelivered(y, 'delivered')" v-model="y.qtyDelivered"
                                step="any" :max="y.max" min="0" placeholder="Enter Delivered Items..." class="form-control"
                                :class="{
                                'is-invalid':
                                    submitted &&
                                    (checkQtyEmpty(y.max, y.qtyPending) ||
                                    checkMax(y.qtyDelivered, y.max))
                                }" autocomplete="off" />
                            <div v-if="submitted && checkMax(y.quantity, y.max)" class="invalid-feedback">
                                <span>This value must be less than or equal to
                                {{ y.max }}.</span>
                            </div>
                            </td>
                            <td class="py-2 pe-2 align-top text-warning">
                            <input type="number" @input="checkQtyDelivered(y, 'waived')" v-model="y.qtyWaived" step="any"
                                :max="y.max" min="0" placeholder="Enter Waived Items..." class="form-control" :class="{
                                'is-invalid':
                                    submitted &&
                                    (checkQtyEmpty(y.max, y.qtyPending) ||
                                    checkMax(y.qtyWaived, y.max))
                                }" autocomplete="off" />
                            <div v-if="submitted && checkMax(y.quantity, y.max)" class="invalid-feedback">
                                <span>This value must be less than or equal to
                                {{ y.max }}.</span>
                            </div>
                            </td>
                            <td class="py-2 pe-2 align-top text-warning">
                            <input id="qtyDelivered" type="number" v-model="y.qtyPending" step="any" disabled
                                class="form-control" autocomplete="off" />
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
                <div class="d-flex flex-row-reverse mb-3">
                    <button class="btn btn-primary mt-3" type="submit">Submit</button>
                </div>
            </form>
        </div>
        <Warehouse ref="warehouse" @dropData="dropWarehouse($event)"></Warehouse>
    </b-modal>
</template>